/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: frLTK57AGre4oWC8c14hh8
// Component: qIH0t4nqWOj_

import * as React from "react";

import Head from "next/head";
import Link, { LinkProps } from "next/link";
import { useRouter } from "next/router";

import {
  Flex as Flex__,
  MultiChoiceArg,
  PlasmicDataSourceContextProvider as PlasmicDataSourceContextProvider__,
  PlasmicIcon as PlasmicIcon__,
  PlasmicImg as PlasmicImg__,
  PlasmicLink as PlasmicLink__,
  PlasmicPageGuard as PlasmicPageGuard__,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  Stack as Stack__,
  StrictProps,
  Trans as Trans__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants,
  generateOnMutateForSpec,
  generateStateOnChangeProp,
  generateStateOnChangePropForCodeComponents,
  generateStateValueProp,
  get as $stateGet,
  hasVariant,
  initializeCodeComponentStates,
  initializePlasmicStates,
  makeFragment,
  omit,
  pick,
  renderPlasmicSlot,
  set as $stateSet,
  useCurrentUser,
  useDollarState,
  usePlasmicTranslator,
  useTrigger,
  wrapWithClassName
} from "@plasmicapp/react-web";
import {
  DataCtxReader as DataCtxReader__,
  useDataEnv,
  useGlobalActions
} from "@plasmicapp/react-web/lib/host";

import Button from "../../Button"; // plasmic-import: Cr5zp7a53Igt/component
import { _useGlobalVariants } from "./plasmic"; // plasmic-import: frLTK57AGre4oWC8c14hh8/projectModule
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: frLTK57AGre4oWC8c14hh8/styleTokensProvider

import "@plasmicapp/react-web/lib/plasmic.css";

import sty from "./PlasmicRemarketing.module.css"; // plasmic-import: qIH0t4nqWOj_/css

import CircleIcon from "./icons/PlasmicIcon__Circle"; // plasmic-import: 9sHJQRmA0elH/icon
import ChevronDownIcon from "./icons/PlasmicIcon__ChevronDown"; // plasmic-import: BcA8RyhY-uEx/icon

const emptyProxy: any = new Proxy(() => "", {
  get(_, prop) {
    return prop === Symbol.toPrimitive ? () => "" : emptyProxy;
  }
});

function wrapQueriesWithLoadingProxy($q: any): any {
  return new Proxy($q, {
    get(target, queryName) {
      const query = target[queryName];
      return !query || query.isLoading || !query.data ? emptyProxy : query;
    }
  });
}

export type PageCtx = {
  pageRoute: string;
  pagePath: string;
  params: Record<string, string | string[] | undefined>;
  query: Record<string, string | string[] | undefined>;
};

export function generateDynamicMetadata($q: any, $ctx: PageCtx) {
  return {
    title: "Souhlas se zpracováním osobních údajů",

    openGraph: {
      title: "Souhlas se zpracováním osobních údajů"
    },
    twitter: {
      card: "summary" as const,
      title: "Souhlas se zpracováním osobních údajů"
    }
  };
}

createPlasmicElementProxy;

export type PlasmicRemarketing__VariantMembers = {};
export type PlasmicRemarketing__VariantsArgs = {};
type VariantPropType = keyof PlasmicRemarketing__VariantsArgs;
export const PlasmicRemarketing__VariantProps = new Array<VariantPropType>();

export type PlasmicRemarketing__ArgsType = {};
type ArgPropType = keyof PlasmicRemarketing__ArgsType;
export const PlasmicRemarketing__ArgProps = new Array<ArgPropType>();

export type PlasmicRemarketing__OverridesType = {
  root?: Flex__<"div">;
  freeBox?: Flex__<"div">;
  h1?: Flex__<"h1">;
  button?: Flex__<typeof Button>;
};

export interface DefaultRemarketingProps {}

const $$ = {};

function useNextRouter() {
  try {
    return useRouter();
  } catch {}
  return undefined;
}

function PlasmicRemarketing__RenderFunc(props: {
  variants: PlasmicRemarketing__VariantsArgs;
  args: PlasmicRemarketing__ArgsType;
  overrides: PlasmicRemarketing__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants
  };

  const __nextRouter = useNextRouter();

  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const pageMetadata = generateDynamicMetadata(
    wrapQueriesWithLoadingProxy({}),
    $ctx as PageCtx
  );

  const styleTokensClassNames = _useStyleTokens();

  return (
    <React.Fragment>
      <Head>
        <meta name="twitter:card" content="summary" />
        <title key="title">{pageMetadata.title}</title>
        <meta key="og:title" property="og:title" content={pageMetadata.title} />
        <meta
          key="twitter:title"
          property="twitter:title"
          content={pageMetadata.title}
        />
      </Head>

      <style>{`
        body {
          margin: 0;
        }
      `}</style>

      <div className={"plasmic_page_wrapper"}>
        <div
          data-plasmic-name={"root"}
          data-plasmic-override={overrides.root}
          data-plasmic-root={true}
          data-plasmic-for-node={forNode}
          className={classNames(
            "all",
            "root_reset_frLTK57AGre4oWC8c14hh8",
            "plasmic_default_styles",
            "plasmic_mixins",
            styleTokensClassNames,
            sty.root
          )}
        >
          <div
            data-plasmic-name={"freeBox"}
            data-plasmic-override={overrides.freeBox}
            className={classNames("all", sty.freeBox)}
          >
            <h1
              data-plasmic-name={"h1"}
              data-plasmic-override={overrides.h1}
              className={classNames(
                "all",
                "h1",
                "h1__frLTK",
                "__wab_text",
                sty.h1
              )}
            >
              {"Souhlas se zpracov\u00e1n\u00edm osobn\u00edch \u00fadaj\u016f"}
            </h1>
            <div className={classNames("all", "__wab_text", sty.text___8P0TJ)}>
              <React.Fragment>
                <span
                  className={
                    "plasmic_default__all plasmic_default__span plasmic_default__span__frLTK"
                  }
                  style={{ fontStyle: "italic" }}
                >
                  {
                    "dle ustanoven\u00ed \u010dl. 6, odst. 1, p\u00edsm. a) na\u0159\u00edzen\u00ed Evropsk\u00e9ho parlamentu a Rady (EU) \u010d. 2016/679 ze dne 27. dubna 2016, o ochran\u011b fyzick\u00fdch osob v souvislosti se zpracov\u00e1n\u00edm osobn\u00edch \u00fadaj\u016f a o voln\u00e9m pohybu t\u011bchto \u00fadaj\u016f"
                  }
                </span>
                <React.Fragment>{"\n(d\u00e1le jen jako "}</React.Fragment>
                <span
                  className={
                    "plasmic_default__all plasmic_default__span plasmic_default__span__frLTK"
                  }
                  style={{ fontWeight: 700 }}
                >
                  {"\u201eNa\u0159\u00edzen\u00ed\u201c"}
                </span>
                <React.Fragment>
                  {
                    ")\nve spojen\u00ed se z\u00e1konem \u010d. 110/2019 Sb., o zpracov\u00e1n\u00ed osobn\u00edch \u00fadaj\u016f, v platn\u00e9m zn\u011bn\u00ed za\u0161krtnut\u00edm nep\u0159edvypln\u011bn\u00e9ho pole \u201eSouhlas\u00edm se zpracov\u00e1n\u00edm osobn\u00edch \u00fadaj\u016f za \u00fa\u010delem obchodn\u00ed a marketingov\u00e9 komunikace\u201c ud\u011blujete spole\u010dnosti "
                  }
                </React.Fragment>
                <span
                  className={
                    "plasmic_default__all plasmic_default__span plasmic_default__span__frLTK"
                  }
                  style={{ fontWeight: 700 }}
                >
                  {"FinBakers s.r.o."}
                </span>
                <React.Fragment>
                  {
                    ", Na Folimance 2155/15, Vinohrady (Praha 2), 120 00 Praha, I\u010cO: 091 515 41, zapsan\u00e1 v obchodn\u00edm rejst\u0159\u00edku veden\u00e9m M\u011bstsk\u00fdm soudem v Praze pod sp. zn. C 331699, "
                  }
                </React.Fragment>
                <span
                  className={
                    "plasmic_default__all plasmic_default__span plasmic_default__span__frLTK"
                  }
                  style={{ fontWeight: 700 }}
                >
                  {
                    "souhlas se zpracov\u00e1n\u00edm osobn\u00edch \u00fadaj\u016f"
                  }
                </span>
                <React.Fragment>
                  {
                    " k p\u0159ed\u00e1n\u00edm Va\u0161ich osobn\u00edch \u00fadaj\u016f dal\u0161\u00edm p\u0159\u00edjemc\u016fm, a to:"
                  }
                </React.Fragment>
              </React.Fragment>
            </div>
            <div className={classNames("all", "__wab_text", sty.text___8S2G)}>
              {
                "1. v rozsahu identifika\u010dn\u00edch \u00fadaj\u016f, adresn\u00edch a kontaktn\u00edch \u00fadaj\u016f, v\u010detn\u011b \u010d\u00edsla bankovn\u00edho \u00fa\u010dtu, za \u00fa\u010delem p\u0159\u00edm\u00e9ho marketingu, tedy za \u00fa\u010delem\n        - periodick\u00e9ho a opakovan\u00e9ho zas\u00edl\u00e1n\u00ed informac\u00ed o aktu\u00e1ln\u00edch nab\u00eddk\u00e1ch na produkty a slu\u017eby prost\u0159ednictv\u00edm e-mailu \u010di sms zpr\u00e1v;\n        - poskytov\u00e1n\u00ed obchodn\u00edch nab\u00eddek prost\u0159ednictv\u00edm telefonu;\n        - zas\u00edl\u00e1n\u00ed informac\u00ed o po\u0159\u00e1dan\u00fdch akc\u00edch, v\u00fdrobc\u00edch, slu\u017eb\u00e1ch a jin\u00fdch aktivit\u00e1ch;\n        - kontaktov\u00e1n\u00ed za \u00fa\u010delem pr\u016fzkumu trhu a za \u00fa\u010delem marketingov\u00fdch v\u00fdzkum\u016f, a to elektronickou \u010di telefonickou formou;\n        spole\u010dnostem:"
              }
            </div>
            <div className={classNames("all", "__wab_text", sty.text__pXsM)}>
              <React.Fragment>
                <React.Fragment>{""}</React.Fragment>
                {
                  <ul
                    className={classNames(
                      "all",
                      "ul",
                      "ul__frLTK",
                      sty.ul___6ERff
                    )}
                  >
                    <li
                      className={classNames(
                        "all",
                        "li",
                        "li__frLTK",
                        "__wab_text",
                        sty.li___2VkXe
                      )}
                    >
                      {"dotFOX s.r.o., I\u010c: 2614791,"}
                    </li>
                    <li
                      className={classNames(
                        "all",
                        "li",
                        "li__frLTK",
                        "__wab_text",
                        sty.li__y8YHt
                      )}
                    >
                      {"Elephant Orchestra, s.r.o., I\u010c: 3272974,"}
                    </li>
                    <li
                      className={classNames(
                        "all",
                        "li",
                        "li__frLTK",
                        "__wab_text",
                        sty.li__w1RsN
                      )}
                    >
                      {"FinBakers s.r.o., I\u010c: 9151541,"}
                    </li>
                    <li
                      className={classNames(
                        "all",
                        "li",
                        "li__frLTK",
                        "__wab_text",
                        sty.li__zBue2
                      )}
                    >
                      {"LIFO \u2013 CB, s.r.o., I\u010c: 28114132,"}
                    </li>
                  </ul>
                }
                <React.Fragment>{""}</React.Fragment>
                {
                  <ul
                    className={classNames(
                      "all",
                      "ul",
                      "ul__frLTK",
                      sty.ul__x1PsV
                    )}
                  >
                    <li
                      className={classNames(
                        "all",
                        "li",
                        "li__frLTK",
                        "__wab_text",
                        sty.li___0L9Vt
                      )}
                    >
                      {"VOLSOR s.r.o. , I\u010c: 1385011,"}
                    </li>
                    <li
                      className={classNames(
                        "all",
                        "li",
                        "li__frLTK",
                        "__wab_text",
                        sty.li__tAJdG
                      )}
                    >
                      {"Messente Communications Ltd., Reg. Code: 12418041,"}
                    </li>
                    <li
                      className={classNames(
                        "all",
                        "li",
                        "li__frLTK",
                        "__wab_text",
                        sty.li__pqqQh
                      )}
                    >
                      {"Webkomplet, s.r.o.; I\u010c: 29185084,"}
                    </li>
                    <li
                      className={classNames(
                        "all",
                        "li",
                        "li__frLTK",
                        "__wab_text",
                        sty.li__kf6Yf
                      )}
                    >
                      {"Seznam.cz , a.s., I\u010c: 26168685,"}
                    </li>
                    <li
                      className={classNames(
                        "all",
                        "li",
                        "li__frLTK",
                        "__wab_text",
                        sty.li__zSks0
                      )}
                    >
                      {"Google Czech Republic, s.r.o., I\u010c: 27604977,"}
                    </li>
                    <li
                      className={classNames(
                        "all",
                        "li",
                        "li__frLTK",
                        "__wab_text",
                        sty.li__bjlDi
                      )}
                    >
                      {"Fincollect SE, I\u010c: 06435238,"}
                    </li>
                    <li
                      className={classNames(
                        "all",
                        "li",
                        "li__frLTK",
                        "__wab_text",
                        sty.li__fkxDt
                      )}
                    >
                      {"Comfort Money s.r.o., I\u010c: 24209589,"}
                    </li>
                    <li
                      className={classNames(
                        "all",
                        "li",
                        "li__frLTK",
                        "__wab_text",
                        sty.li__pcxDn
                      )}
                    >
                      {"COOL CREDIT, s.r.o., I\u010c: 02112621,"}
                    </li>
                    <li
                      className={classNames(
                        "all",
                        "li",
                        "li__frLTK",
                        "__wab_text",
                        sty.li__likpg
                      )}
                    >
                      {"CentroFinance, s.r.o., I\u010c: 03057151,"}
                    </li>
                    <li
                      className={classNames(
                        "all",
                        "li",
                        "li__frLTK",
                        "__wab_text",
                        sty.li__pt7Pw
                      )}
                    >
                      {"Creamfinance Czech, s.r.o., I\u010c: 24849707,"}
                    </li>
                    <li
                      className={classNames(
                        "all",
                        "li",
                        "li__frLTK",
                        "__wab_text",
                        sty.li__e0VH
                      )}
                    >
                      {"Kontex Trade International s.r.o., I\u010c: 24827061,"}
                    </li>
                    <li
                      className={classNames(
                        "all",
                        "li",
                        "li__frLTK",
                        "__wab_text",
                        sty.li__iCpEe
                      )}
                    >
                      {"Orange finance s.r.o., I\u010c: 04488237,"}
                    </li>
                    <li
                      className={classNames(
                        "all",
                        "li",
                        "li__frLTK",
                        "__wab_text",
                        sty.li__uDlKg
                      )}
                    >
                      {"Rerum Finance, s.r.o., I\u010c: 03210235,"}
                    </li>
                    <li
                      className={classNames(
                        "all",
                        "li",
                        "li__frLTK",
                        "__wab_text",
                        sty.li__ofNid
                      )}
                    >
                      {"SWISS FUNDS, a.s., I\u010c: 05421721,"}
                    </li>
                    <li
                      className={classNames(
                        "all",
                        "li",
                        "li__frLTK",
                        "__wab_text",
                        sty.li__uw8JF
                      )}
                    >
                      {"Via SMS s.r.o., I\u010c: 24720275,"}
                    </li>
                    <li
                      className={classNames(
                        "all",
                        "li",
                        "li__frLTK",
                        "__wab_text",
                        sty.li__hc5RV
                      )}
                    >
                      {"Tando Financial a.s., I\u010c: 08314209,"}
                    </li>
                    <li
                      className={classNames(
                        "all",
                        "li",
                        "li__frLTK",
                        "__wab_text",
                        sty.li___8QwRo
                      )}
                    >
                      {"Zaplo Finance s.r.o., I\u010c: 29413575."}
                    </li>
                  </ul>
                }
                <React.Fragment>{""}</React.Fragment>
              </React.Fragment>
            </div>
            <div className={classNames("all", "__wab_text", sty.text__z9DUk)}>
              <React.Fragment>
                <React.Fragment>
                  {
                    "2. v rozsahu identifika\u010dn\u00edch \u00fadaj\u016f, adresn\u00edch a kontaktn\u00edch \u00fadaj\u016f za \u00fa\u010delem p\u0159ed\u00e1n\u00ed spole\u010dnostem:\n\n- "
                  }
                </React.Fragment>
                <span
                  className={
                    "plasmic_default__all plasmic_default__span plasmic_default__span__frLTK"
                  }
                  style={{ fontWeight: 700 }}
                >
                  {"WeAgency OU"}
                </span>
                <React.Fragment>
                  {
                    ", soukrom\u00e1 akciov\u00e1 spole\u010dnost registrovan\u00e1 podle z\u00e1kon\u016f Estonsk\u00e9 republiky, registra\u010dn\u00ed k\u00f3d 16154308, se s\u00eddlem Tallinn, Lasnam\u00e4e Linnaosa, Paepargi TN 47-9, 11417, Estonsko (d\u00e1le jen \u201eWeAgency\u201c),\n- "
                  }
                </React.Fragment>
                <span
                  className={
                    "plasmic_default__all plasmic_default__span plasmic_default__span__frLTK"
                  }
                  style={{ fontWeight: 700 }}
                >
                  {"Philip Morris \u010cR a.s."}
                </span>
                <React.Fragment>
                  {
                    ", I\u010c: 14803534, se s\u00eddlem V\u00edt\u011bzn\u00e1 1, Sedlec, 284 03 Kutn\u00e1 Hora, \u010cesk\u00e1 republika (d\u00e1le jen \u201e"
                  }
                </React.Fragment>
                <span
                  className={
                    "plasmic_default__all plasmic_default__span plasmic_default__span__frLTK"
                  }
                  style={{ fontWeight: 700 }}
                >
                  {"Philip Morris"}
                </span>
                <React.Fragment>{"\u201c)."}</React.Fragment>
              </React.Fragment>
            </div>
            <div className={classNames("all", "__wab_text", sty.text__kMQjA)}>
              {
                "Spole\u010dnosti WeAgency a Philip Morris osobn\u00ed \u00fadaje zpracov\u00e1vaj\u00ed za \u00fa\u010delem Va\u0161e kontaktov\u00e1n\u00ed prost\u0159ednictv\u00edm e-mailov\u00e9 adresy, telefonn\u00edho \u010d\u00edsla a internetu (v\u010detn\u011b SMS, MMS a jin\u00fdch typ\u016f zpr\u00e1v na m\u00e9 telefonn\u00ed \u010d\u00edslo, e-mail a/nebo soci\u00e1ln\u00ed s\u00edt\u011b) s informacemi o aktivit\u00e1ch spole\u010dnosti Philip Morris, kter\u00e9 tato spole\u010dnost prov\u00e1d\u00ed v souladu s platn\u00fdmi pr\u00e1vn\u00edmi p\u0159edpisy v souvislosti s elektrick\u00fdmi syst\u00e9my pro oh\u0159ev tab\u00e1ku, za\u0159\u00edzen\u00edmi pro konzumaci nikotinov\u00fdch v\u00fdrobk\u016f a/nebo jejich p\u0159\u00edslu\u0161enstv\u00edm, tab\u00e1kov\u00fdmi v\u00fdrobky a dal\u0161\u00edmi nikotinov\u00fdmi produkty, v\u010detn\u011b jejich vlastnost\u00ed a dal\u0161\u00edch specifik pod ochrann\u00fdmi zn\u00e1mkami (zna\u010dkami), k nim\u017e je Philip Morris bu\u010f dr\u017eitelem pr\u00e1v, nebo licencovan\u00fdm u\u017eivatelem; prov\u00e1d\u011bn\u00ed marketingov\u00fdch a sociologick\u00fdch v\u00fdzkum\u016f a anal\u00fdz, vytv\u00e1\u0159en\u00ed jak\u00fdchkoliv program\u016f, v\u010detn\u011b program\u016f pro tvorbu a generov\u00e1n\u00ed datab\u00e1z\u00ed, sestavov\u00e1n\u00ed statistick\u00fdch zpr\u00e1v a zaji\u0161t\u011bn\u00ed souladu s po\u017eadavky platn\u00e9 legislativy; zas\u00edl\u00e1n\u00ed obecn\u00fdch novinek, v\u010detn\u011b zm\u011bn pr\u00e1vn\u00edch p\u0159edpis\u016f; poskytov\u00e1n\u00ed informac\u00ed o tab\u00e1kov\u00fdch a/nebo nikotinov\u00fdch v\u00fdrobc\u00edch identifikovan\u00fdch pod zna\u010dkami, k nim\u017e je Philip Morris bu\u010f dr\u017eitelem autorsk\u00fdch pr\u00e1v, nebo licencovan\u00fdm u\u017eivatelem, zejm\u00e9na o jejich vlastnostech, cen\u00e1ch a m\u00edstech prodeje t\u011bchto produkt\u016f v m\u00e9m m\u011bst\u011b/regionu; poskytov\u00e1n\u00ed informac\u00ed o ud\u00e1lostech, sout\u011b\u017e\u00edch, cen\u00e1ch, projektech, nab\u00eddk\u00e1ch slu\u017eeb a aktivit\u00e1ch dostupn\u00fdch v m\u00e9m m\u011bst\u011b/regionu; pozv\u00e1n\u00ed na webov\u00e9 str\u00e1nky a/nebo mobiln\u00ed aplikace spole\u010dnosti Philip Morris a/nebo jej\u00edch p\u0159idru\u017een\u00fdch spole\u010dnost\u00ed a/nebo webov\u00e9 str\u00e1nky/mobiln\u00ed aplikace t\u0159et\u00edch stran autorizovan\u00fdch t\u011bmito spole\u010dnostmi; registrace do datab\u00e1ze z\u00e1kazn\u00edk\u016f tab\u00e1kov\u00fdch a/nebo jin\u00fdch nikotinov\u00fdch v\u00fdrobk\u016f Philip Morris.\n\nSpole\u010dnostem Philip Morris a WeAgency jsou osobn\u00ed \u00fadaje p\u0159ed\u00e1v\u00e1ny prost\u0159ednictv\u00edm spole\u010dnosti Aval24 s.r.o.\n\nKter\u00e9koliv z v\u00fd\u0161e uveden\u00fdch d\u016fvod\u016f zpracov\u00e1n\u00ed je dobrovoln\u00e9 a ud\u011blen\u00ed \u010di neud\u011blen\u00ed souhlasu nem\u00e1 \u017e\u00e1dn\u00fd vliv na uzav\u0159en\u00ed smlouvy o zprost\u0159edkov\u00e1n\u00ed \u00fav\u011bru mezi V\u00e1mi a spole\u010dnost\u00ed FinBakers s.r.o. Souhlas ud\u011blujete na dobu 10 let ode dne ud\u011blen\u00ed tohoto souhlasu. Tento souhlas lze kdykoliv odvolat, a to i jen z \u010d\u00e1sti pro kter\u00fdkoliv z d\u016fvod\u016f uveden\u00fdch v tomto souhlasu nebo pro kteroukoliv z v\u00fd\u0161e uveden\u00fdch spole\u010dnost\u00ed, a to koresponden\u010dn\u011b na adresu spole\u010dnosti.\n\nPo p\u0159ed\u00e1n\u00ed osobn\u00edch \u00fadaj\u016f jin\u00e9mu spr\u00e1vci spole\u010dnost FinBakers s.r.o. nenese odpov\u011bdnost za zpracov\u00e1n\u00ed osobn\u00edch \u00fadaj\u016f t\u00edmto samostatn\u00fdm spr\u00e1vcem.\n\nVezm\u011bte, pros\u00edme, na v\u011bdom\u00ed, \u017ee podle Na\u0159\u00edzen\u00ed m\u00e1te pr\u00e1vo:"
              }
            </div>
            <div className={classNames("all", "__wab_text", sty.text__bzwo4)}>
              <React.Fragment>
                <React.Fragment>{""}</React.Fragment>
                {
                  <ul
                    className={classNames(
                      "all",
                      "ul",
                      "ul__frLTK",
                      sty.ul__zNnAh
                    )}
                  >
                    <li
                      className={classNames(
                        "all",
                        "li",
                        "li__frLTK",
                        "__wab_text",
                        sty.li__ejszj
                      )}
                    >
                      {
                        "zru\u0161it kdykoliv zas\u00edl\u00e1n\u00ed obchodn\u00edch sd\u011blen\u00ed,"
                      }
                    </li>
                    <li
                      className={classNames(
                        "all",
                        "li",
                        "li__frLTK",
                        "__wab_text",
                        sty.li___0QQsb
                      )}
                    >
                      {
                        "vzn\u00e9st n\u00e1mitku proti zpracov\u00e1n\u00ed na z\u00e1klad\u011b na\u0161eho opr\u00e1vn\u011bn\u00e9ho z\u00e1jmu,"
                      }
                    </li>
                    <li
                      className={classNames(
                        "all",
                        "li",
                        "li__frLTK",
                        "__wab_text",
                        sty.li__lzFD
                      )}
                    >
                      {
                        "po\u017eadovat po n\u00e1s informaci, jak\u00e9 va\u0161e osobn\u00ed \u00fadaje zpracov\u00e1v\u00e1me,\n"
                      }
                    </li>
                    <li
                      className={classNames(
                        "all",
                        "li",
                        "li__frLTK",
                        "__wab_text",
                        sty.li__ptIGg
                      )}
                    >
                      {
                        "vy\u017e\u00e1dat si u n\u00e1s p\u0159\u00edstup k t\u011bmto \u00fadaj\u016fm a tyto nechat aktualizovat nebo opravit, pop\u0159\u00edpad\u011b po\u017eadovat omezen\u00ed zpracov\u00e1n\u00ed,"
                      }
                    </li>
                    <li
                      className={classNames(
                        "all",
                        "li",
                        "li__frLTK",
                        "__wab_text",
                        sty.li__fnOgf
                      )}
                    >
                      {
                        "po\u017eadovat po n\u00e1s v\u00fdmaz t\u011bchto osobn\u00edch \u00fadaj\u016f, v\u00fdmaz provedeme, pokud to nebude v rozporu s platn\u00fdmi pr\u00e1vn\u00edmi p\u0159edpisy nebo na\u0161imi opr\u00e1vn\u011bn\u00fdmi z\u00e1jmy,"
                      }
                    </li>
                    <li
                      className={classNames(
                        "all",
                        "li",
                        "li__frLTK",
                        "__wab_text",
                        sty.li__kn6L
                      )}
                    >
                      {
                        "na p\u0159enositelnost \u00fadaj\u016f, pokud se jedn\u00e1 o automatizovan\u00e9 zpracov\u00e1n\u00ed na z\u00e1klad\u011b souhlasu nebo z d\u016fvodu pln\u011bn\u00ed smlouvy,"
                      }
                    </li>
                    <li
                      className={classNames(
                        "all",
                        "li",
                        "li__frLTK",
                        "__wab_text",
                        sty.li__knoRw
                      )}
                    >
                      {
                        "po\u017eadovat kopii zpracov\u00e1van\u00fdch osobn\u00edch \u00fadaj\u016f,"
                      }
                    </li>
                    <li
                      className={classNames(
                        "all",
                        "li",
                        "li__frLTK",
                        "__wab_text",
                        sty.li__gY5N8
                      )}
                    >
                      {
                        "na \u00fa\u010dinnou soudn\u00ed ochranu, pokud m\u00e1te za to, \u017ee va\u0161e pr\u00e1va podle Na\u0159\u00edzen\u00ed byla poru\u0161ena v d\u016fsledku zpracov\u00e1n\u00ed va\u0161ich osobn\u00edch \u00fadaj\u016f v rozporu s t\u00edmto Na\u0159\u00edzen\u00edm,"
                      }
                    </li>
                    <li
                      className={classNames(
                        "all",
                        "li",
                        "li__frLTK",
                        "__wab_text",
                        sty.li__nkGfw
                      )}
                    >
                      {
                        "podat st\u00ed\u017enost u \u00da\u0159adu pro ochranu osobn\u00edch \u00fadaj\u016f (Pplk. Sochora 27, 170 00 Praha 7, e-mail: posta@uoou.cz, ID datov\u00e9 schr\u00e1nky: qkbaa2n)"
                      }
                    </li>
                  </ul>
                }
                <React.Fragment>{""}</React.Fragment>
              </React.Fragment>
            </div>
            <div className={classNames("all", "__wab_text", sty.text__ob9T8)}>
              {""}
            </div>
            <Button
              data-plasmic-name={"button"}
              data-plasmic-override={overrides.button}
              className={classNames("__wab_instance", sty.button)}
              color={"success"}
              label={
                <div
                  className={classNames("all", "__wab_text", sty.text__rcGjv)}
                >
                  {"P\u0159e\u010detl/a jsem si podm\u00ednky slu\u017eby"}
                </div>
              }
              onClick={async event => {
                const $steps = {};

                $steps["runCode"] = true
                  ? (() => {
                      const actionArgs = {
                        customFunction: async () => {
                          return window.close();
                        }
                      };
                      return (({ customFunction }) => {
                        return customFunction();
                      })?.apply(null, [actionArgs]);
                    })()
                  : undefined;
                if (
                  $steps["runCode"] != null &&
                  typeof $steps["runCode"] === "object" &&
                  typeof $steps["runCode"].then === "function"
                ) {
                  $steps["runCode"] = await $steps["runCode"];
                }
              }}
              size={"large"}
            />
          </div>
        </div>
      </div>
    </React.Fragment>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  root: ["root", "freeBox", "h1", "button"],
  freeBox: ["freeBox", "h1", "button"],
  h1: ["h1"],
  button: ["button"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  root: "div";
  freeBox: "div";
  h1: "h1";
  button: typeof Button;
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicRemarketing__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicRemarketing__VariantsArgs;
    args?: PlasmicRemarketing__ArgsType;
    overrides?: NodeOverridesType<T>;
  } &
    // Specify variants directly as props
    Omit<PlasmicRemarketing__VariantsArgs, ReservedPropsType> &
    // Specify args directly as props
    Omit<PlasmicRemarketing__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicRemarketing__ArgProps,
          internalVariantPropNames: PlasmicRemarketing__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicRemarketing__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicRemarketing";
  } else {
    func.displayName = `PlasmicRemarketing.${nodeName}`;
  }
  return func;
}

export const PlasmicRemarketing = Object.assign(
  // Top-level PlasmicRemarketing renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    freeBox: makeNodeComponent("freeBox"),
    h1: makeNodeComponent("h1"),
    button: makeNodeComponent("button"),

    // Metadata about props expected for PlasmicRemarketing
    internalVariantProps: PlasmicRemarketing__VariantProps,
    internalArgProps: PlasmicRemarketing__ArgProps,

    pageMetadata: generateDynamicMetadata(wrapQueriesWithLoadingProxy({}), {
      pageRoute: "/remarketing",
      pagePath: "/remarketing",
      params: {},
      query: {}
    })
  }
);

export default PlasmicRemarketing;
/* prettier-ignore-end */
